import { API_ENDPOINTS } from '../config/api'
import { USE_MOCK_API } from './useMockApi'
import { mockJsonResponse } from './mockJsonResponse'
import suppliersFixture from './fixtures/suppliers.json'
import assetsFixture from './fixtures/assets.json'

export function fetchSuppliersListForHome(): Promise<Response> {
  if (USE_MOCK_API) return Promise.resolve(mockJsonResponse(suppliersFixture))
  return fetch('/api/suppliers', {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export function fetchAssetsListForHome(organizationParam: string | null): Promise<Response> {
  if (USE_MOCK_API) return Promise.resolve(mockJsonResponse(assetsFixture))
  const assetsListUrl = organizationParam
    ? `${API_ENDPOINTS.ASSETS}?organization_id=${encodeURIComponent(String(organizationParam))}`
    : API_ENDPOINTS.ASSETS
  return fetch(assetsListUrl, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` },
  })
}
